export default [
  { id: '1', name: '50 teams' },
  { id: '2', name: '100 teams' },
  { id: '3', name: '150 teams' },
  { id: '4', name: '200 teams' },
  { id: '5', name: '250 teams' },
  { id: '6', name: '300 teams' },
  { id: '7', name: '350 teams' },
  { id: '8', name: '400 teams' },
  { id: '9', name: '450 teams' },
  { id: '10', name: '500 teams' },
  { id: '11', name: '550 teams' },
  { id: '12', name: '600 teams' },
  { id: '13', name: '650 teams' },
  { id: '14', name: '700 teams' },
  { id: '15', name: '750 teams' },
  { id: '16', name: '800 teams' },
  { id: '17', name: '850 teams' },
  { id: '18', name: '900 teams' },
  { id: '19', name: '950 teams' },
  { id: '20', name: '1000 teams' },
  { id: '21', name: '1050 teams' },
  { id: '22', name: '1100 teams' },
  { id: '23', name: '1150 teams' },
  { id: '24', name: '1200 teams' },
  { id: '25', name: '1250 teams' },
  { id: '26', name: '1300 teams' },
  { id: '27', name: '1350 teams' },
  { id: '28', name: '1400 teams' },
  { id: '29', name: '1450 teams' },
  { id: '30', name: '1500 teams' },
  { id: '31', name: '1550 teams' },
  { id: '32', name: '1600 teams' },
  { id: '33', name: '1650 teams' },
  { id: '34', name: '1700 teams' },
  { id: '35', name: '1750 teams' },
  { id: '36', name: '1800 teams' },
  { id: '37', name: '1850 teams' },
  { id: '38', name: '1900 teams' },
  { id: '39', name: '1950 teams' },
  { id: '40', name: '2000 teams' },
];
